import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './ChevronToggle.scss';

const ChevronToggle = ({ className, isActive }) => {
    const thisClass = classNames(className, {
        'chevron-toggle': true,
        'chevron-toggle-active': isActive,
    });

    return <span className={thisClass} />;
};

ChevronToggle.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

export default React.memo(ChevronToggle);

